angular.module('bmsApp.trugreen.job').factory('TGTreatmentProductSvc', function (CRUDSvc, $modal, $rootScope) {

	var self = {
		index: function(params) {
			return CRUDSvc.get('api/trugreen/treatmentProducts/index', params);
		},
		showTreatmentProductModal: function(tgTreatment, tgProduct) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/trugreen/job/templates/TreatmentProductModal.html',
				controller: 'TGTreatmentProductModalCtrl',
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					tgTreatment: function () {
						return angular.copy(tgTreatment);
					},
					tgProduct: function () {
						return angular.copy(tgProduct);
					}
				}
			});

			return modalInstance.result;
		}
	};
	return self;

});
